import axios from "axios";

const participantes = {
  state: () => ({
    participantes: [],
    participante: {},

    participantesWorldskills: [],
    
    participantesCampesena: [],
    participanteCampesena: {},

  }),

  getters: {
    obtenerParticipantes: (state) => (categoria, centroFormacion) => {
      return state.participantes.filter(participante => participante.categoria_id == categoria 
        && participante.centro_formacion_id == centroFormacion);
    },

    obtenerParticipante(state) {
      return state.participante;
    },

    obtenerParticipantesWorldskills: (state) => (competencia, habilidad) => {
      return state.participantesWorldskills.filter(
        (participante) =>
          participante.competencia_id == competencia &&
          participante.categoria_id == habilidad
      );
    },

    obtenerParticipanteWorldskills: (state) => (id) => {
      return state.participantesWorldskills.find(
        (participante) => participante.id == id
      );
    },

    obtenerParticipantesCampesena(state) {
      return state.participantesCampesena;
    },

    obtenerParticipanteCampesena(state) {
      return state.participanteCampesena;
    },

    obtenerParticipantesCentroFormacionCampesena:
      (state) => (saberId, centroFormacionId) => {
        return state.participantesCampesena.filter(
          (participante) =>
            participante.saber_id == Number(saberId) &&
            participante.centro_formacion_id == centroFormacionId
        );
      },
  },

  mutations: {
    enviarParticipantes(state, participantes) {
      state.participantes = participantes;
    },

    enviarParticipante(state, participante) {
      state.participante = participante;
    },

    enviarParticipantesWorldskills(state, participantesWorldskills) {
      state.participantesWorldskills = participantesWorldskills;
    },

    enviarParticipantesCampesena(state, participantes) {
      state.participantesCampesena = participantes;
    },

    enviarParticipanteCampesena(state, participante) {
      state.participanteCampesena = participante;
    },
  },

  actions: {
    registrarParticipante(context, participante) {
      return new Promise((resolve, reject) => {
        axios.post("api/participantes", participante)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    gestionarParticipantes(context, competencia) {
      axios.get("api/competencias/"+competencia+"/participantes")
      .then((response) => {
        const participantes = [];

        response.data.results.forEach(participante => {
          participantes.push({
            id:                     participante.id_participante,
            competencia_id:         participante.competencia.id_competencia,
            competencia:            participante.competencia.competencia,
            categoria_id:           participante.categoria.id_categoria,
            categoria:              participante.categoria.categoria,
            regional_id:            participante.centro_formacion.regional.id_regional,
            regional:               participante.centro_formacion.regional.regional,
            centro_formacion_id:    participante.centro_formacion.id_centro_formacion,
            centro_formacion:       participante.centro_formacion.centro_formacion,
            programa_formacion_id:  participante.programa_formacion.id_programa_formacion,
            programa_formacion:     participante.programa_formacion.programa_formacion,
            persona_id:             participante.persona.id_persona,
            identificacion:         participante.persona.identificacion,
            nombres:                participante.persona.primer_nombre+" "+participante.persona.segundo_nombre,
            apellidos:              participante.persona.primer_apellido+" " +participante.persona.segundo_apellido,
            correo:                 participante.persona.correo,
            telefono_movil:         participante.persona.telefono_movil
          })
        });

        context.commit("enviarParticipantes", participantes);
      })
      .catch(() => {});
    },

    detallesParticipante(context, id) {
      axios.get("api/participantes/"+id)
      .then((response) => {
        const detalles = response.data.results

        const participante = {
          id:                     detalles.id_participante,
          competencia_id:         detalles.competencia.id_competencia,
          competencia:            detalles.competencia.competencia,
          categoria_id:           detalles.categoria.id_categoria,
          categoria:              detalles.categoria.categoria,
          regional_id:            detalles.centro_formacion.regional.id_regional,
          regional:               detalles.centro_formacion.regional.regional,
          centro_formacion_id:    detalles.centro_formacion.id_centro_formacion,
          centro_formacion:       detalles.centro_formacion.centro_formacion,
          programa_formacion_id:  detalles.programa_formacion.id_programa_formacion,
          programa_formacion:     detalles.programa_formacion.programa_formacion,
          numero_ficha:           detalles.numero_ficha,
          persona_id:             detalles.persona.id_persona,
          tipo_identificacion_id: detalles.persona.tipo_identificacion_id,
          identificacion:         detalles.persona.identificacion,
          nombres:                detalles.persona.primer_nombre+" "+detalles.persona.segundo_nombre,
          apellidos:              detalles.persona.primer_apellido+" " +detalles.persona.segundo_apellido,
          correo:                 detalles.persona.correo,
          telefono_movil:         detalles.persona.telefono_movil,
          direccion:              detalles.persona.direccion,
          fecha_nacimiento:       detalles.persona.fecha_nacimiento,
          genero_id:              detalles.persona.genero_id,
          genero:                 detalles.persona.genero.genero,
          estado_civil_id:        detalles.persona.estado_civil_id,
          estrato:                detalles.persona.estrato,
          zona_id:                detalles.persona.zona_id,
          discapacidad_id:        detalles.persona.discapacidad_id,
          talla_camiseta:         detalles.talla_camiseta,
        };

        context.commit("enviarParticipante", participante);
      })
      .catch(() => {});
    },

    actualizarParticipante(context, participante) {
      return new Promise((resolve, reject) => {
        axios.put("api/participantes/"+participante.id, participante)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    eliminarParticipante(context, id) {
      return new Promise((resolve, reject) => {
        axios.delete("api/participantes/"+id)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },


    // Worldskills
    registrarParticipanteWorldskills(context, participante) {
      return new Promise((resolve, reject) => {
        axios.post("api/participantesWorldskills", participante)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    gestionarParticipantesWorldskills(context) {
      axios.get("api/participantesWorldskills")
      .then((response) => {
        const participantesWorldskills = [];

        response.data.results.forEach((response) => {
          participantesWorldskills.push({
            id: response.id_participante,
            competencia_id: response.id_competencia,
            competencia: response.competencia,
            categoria_id: response.id_categoria,
            categoria: response.categoria,
            centro_formacion_id: response.id_centro_formacion,
            centro_formacion: response.centro_formacion,
            regional_id: response.id_regional,
            regional: response.regional,
            programa_formacion_id: response.id_programa_formacion,
            programa_formacion: response.programa_formacion,
            numero_ficha: response.numero_ficha,
            talla_camiseta: response.talla_camiseta,
            persona_id: response.id_persona,
            tipo_identificacion_id: response.tipo_identificacion_id,
            tipo_identificacion: response.tipo_identificacion,
            identificacion: response.identificacion,
            nombres: response.primer_nombre + " " + response.segundo_nombre,
            apellidos: response.primer_apellido + " " + response.segundo_apellido,
            correo: response.correo,
            telefono_movil: response.telefono_movil,
            direccion: response.direccion,
            fecha_nacimiento: response.fecha_nacimiento,
            genero_id: response.genero_id,
            genero: response.genero,
            estado_civil_id: response.estado_civil_id,
            estado_civil: response.estado_civil,
            estrato: response.estrato,
            zona_id: response.zona_id,
            zona: response.zona,
            discapacidad_id: response.discapacidad_id,
            discapacidad: response.discapacidad,
          });
        });

        context.commit("enviarParticipantesWorldskills", participantesWorldskills);
      })
      .catch(() => {});
    },

    actualizarParticipanteWorldskills(context, participante) {
      return new Promise((resolve, reject) => {
        axios.put("api/participantesWorldskills/" + participante.id, participante)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    eliminarParticipantesWorldSkills(context, participante) {
      return new Promise((resolve, reject) => {
        axios.delete("api/participantesWorldskills/" + participante)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    participantesRegistradosNacional() {
      return new Promise((resolve, reject) => {
        axios.post("api/reportes/GanadoresWorldSkills", { responseType: "blob" })
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    adjudicarParticipantesWorldSkills(context, competencia) {
      return new Promise((resolve, reject) => {
        axios.post("api/participantesWorldskillsAdjudicar", competencia)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },


    // Campesena
    registrarParticipanteCampesena(context, participante) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/campesena/participantes", participante)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    gestionarParticipantesCampesena(context, competenciaId) {
      axios
        .get(`/api/campesena/competencias/${competenciaId}/participantes`)
        .then((response) => {
          const participantessCampesena = [];

          response.data.results.forEach((participante) => {
            participantessCampesena.push({
              id: participante.id_participante,
              competencia_id: participante.competencia_id,
              saber_id: participante.saber_id,
              saber:
                participante.saber.saber.charAt(0).toUpperCase() +
                participante.saber.saber.slice(1),
              centro_formacion_id: participante.centro_formacion_id,
              identificacion: participante.persona.identificacion,
              nombres: `${participante.persona.primer_nombre.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )} ${participante.persona.segundo_nombre.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )}`,
              apellidos: `${participante.persona.primer_apellido.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )} ${participante.persona.segundo_apellido.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )}`,
              correo: participante.persona.correo,
            });
          });

          context.commit(
            "enviarParticipantesCampesena",
            participantessCampesena
          );
        })
        .catch(() => {});
    },
    obtenerParticipanteCampesenaId(context, participanteId) {
         axios
          .get(`/api/campesena/participantes/${participanteId}`)
          .then((response) => {
            const results = response.data.results;
            const participante = {
              id: results.id_participante,
              competencia_id: results.competencia_id,
              competencia: results.competencia.competencia,
              saber_id: results.saber_id,
              saber: results.saber.saber,
              centro_formacion_id: results.centro_formacion_id,
              identificacion: results.persona.identificacion,
              tipo_identificacion_id: results.persona.tipo_identificacion_id,
              nombres: `${results.persona.primer_nombre.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )} ${results.persona.segundo_nombre.replace(/\b\w/g, (char) =>
                char.toUpperCase()
              )}`,
              apellidos: `${results.persona.primer_apellido.replace(
                /\b\w/g,
                (char) => char.toUpperCase()
              )} ${results.persona.segundo_apellido.replace(/\b\w/g, (char) =>
                char.toUpperCase()
              )}`,
              correo: results.persona.correo,
              telefono_movil: results.persona.telefono_movil,
              fecha_nacimiento: results.persona.fecha_nacimiento,
              programa_formacion: results.programa_formacion.programa_formacion,
              programa_formacion_id: results.programa_formacion_id,
              numero_ficha: results.numero_ficha,
              talla_camiseta: results.talla_camiseta,
              centro_formacion: results.centro_formacion.centro_formacion,
              regional: results.centro_formacion.regional.regional,
              direccion: results.persona.direccion,
              genero: results.persona.genero_id,
              estado_civil: results.persona.estado_civil_id,
              estrato: results.persona.estrato,
              zona: results.persona.zona_id,
              discapacidad: results.persona.discapacidad_id,
              tipo_alimentacion: results.persona.tipo_alimentacion_id,
              restriccion_alimentaria: results.persona.restriccion_alimentaria,
              descripcion_restriccion_alimentaria:
                results.persona.descripcion_restriccion_alimentaria,
              enfermedad_existente: results.persona.enfermedad_existente,
              descripcion_enfermedad_existente:
                results.persona.descripcion_enfermedad_existente,
            };
            context.commit("enviarParticipanteCampesena", participante);
          })
          .catch(() => {});
    },
    
    actualizarParticipanteCampesena(context, { participanteId, participante }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/campesena/participantes/${participanteId}`, participante)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    eliminarParticipantesCampesena(context, participanteId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/campesena/participantes/${participanteId}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};

export default participantes;
